import { IOrigins } from '../../shared';

export interface ISupporteeForm {
    id?: string;
    firstName?: string;
    lastName?: string;
    dateOfBirth?: Date | null;
    nationalSecurityNumber?: string;
    gender?: string;
    nationality?: IOrigins | null;
    language?: IOrigins | null;
    relation?: string | null;
    anonymous: boolean;
    dependencyPercentage?: string | number;
}

export const SupporteeDefaults: ISupporteeForm = {
    firstName: '',
    lastName: '',
    dateOfBirth: null,
    nationalSecurityNumber: '',
    gender: '',
    nationality: null,
    language: null,
    relation: null,
    anonymous: false,
};
